module.exports = __webpack_public_path__ + "static/img/lijiang.ee9c1cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/city/lijiang.jpg
// module id = gDa+
// module chunks = 1